<mat-expansion-panel
  class="mat-expansion-panel"
  data-testid="av-check-video-select"
  [expanded]="true"
>
  <mat-expansion-panel-header>
    <mat-panel-title data-testid="av-check-video-title">
      <mat-icon svgIcon="photo_camera"></mat-icon> Camera
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div class="mat-expansion-panel__body">
    <app-select-input
      [dataTestId]="'av-check-camera'"
      [isDisabled]="!audioVideoCheckService.videoInputDevices().length"
      [isFullWidth]="true"
      [label]="'Select Camera'"
      [options]="cameraOptions()"
      [placeholder]="'No Camera Selected'"
      [value]="audioVideoCheckService.selectVideoDevice()?.label || ''"
      (selectionChange)="handleCameraSelectionChange($event)"
    ></app-select-input>
    <ng-container *ngTemplateOutlet="infoIconContainer" />
  </div>
  @if (audioVideoCheckService.hasUserMediaVideoFailure() || !audioVideoCheckService.hasVideo()) {
  <app-av-check-guide
    [showButton]="audioVideoCheckService.isBrowserDetected"
    [(showDetails)]="showVideoGuideDetails"
  >
    <p>
      Hi there! It looks like your camera might be blocked by your browser. Let's get this sorted
      out.
    </p>

    @if (showVideoGuideDetails) { @if (hasLoadingFailure()) {
    <p>
      We're having trouble accessing your camera. Please make sure your camera is connected and try
      again.
    </p>
    } @else { @if (isLoading()) {
    <app-skeleton-text [width]="'med'"/>
    } @else {
    <app-gadget-guide-response
      [gadgetGuide]="gadgetGuideServiceCameraResponse()"
    ></app-gadget-guide-response>
    } } }
  </app-av-check-guide>
  }
</mat-expansion-panel>

<ng-template #infoIconContainer>
  <div class="mat-expansion-panel__info-icon-container">
    @if (audioVideoCheckService.hasVideo()) {
    <mat-icon svgIcon="success" title="Camera Selection Success"></mat-icon>
    } @else {
    <mat-icon svgIcon="error" title="Camera Selection Error"></mat-icon>
    }
  </div>
</ng-template>
